const getWidth = (breakpoint, width) => {
    switch (width) {
    case "100%":
        return "lg:w-full";

    case "50%":
        return "lg:w-1/2";

    case "33%":
        return "lg:w-2/6";

    case "25%":
        return "lg:w-1/4";

    default:
        return "lg:w-2/6";
    }
};

export default getWidth;
